import React from 'react';
import Markdown from 'react-markdown';

export default ({ data }) => (
  <div
    className="full-width-image margin-top-0 custom-footer"
    style={{ height: 'auto', paddingRight: '15px', paddingLeft: '15px' }}
  >
    <div style={{ lineHeight: '1', textAlign: 'center' }}>
      <h2
        className="has-text-weight-bold"
        style={{ color: "white" }}
      >
        {data.title}<br />
        {data.subtitle}
      </h2>
      {
        data.para.map((el, i) => (
          <div key={i}>
            <Markdown children={el} components={{ link: props => <a href={props.href} target="_blank" rel="noopener noreferrer">{props.children}</a> }} />
          </div>
        ))
      }
      <a href="/contact" target="_blank" rel="noopener noreferrer" style={{ color: '#333', display: 'inline-block', margin: '2rem auto 0' }}>
        <button className="btn-light">{data.linkTitle} &#10230;</button>
      </a>
    </div>
  </div>
)
